import { Component, Fragment, h, Prop } from '@stencil/core';
import { store } from "../../../redux/store";
import { closeCart, } from "../../../redux/actions";
import {ComponentView} from "../../../types/types";

@Component({
    tag: 'rentware-checkout-action-bar',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCheckoutActionBar {
    @Prop() buttonNextStepText;
    @Prop() nextClick;
    @Prop() isWaiting: boolean;

    closeCart!: typeof closeCart;

    componentWillLoad() {
        store.mapDispatchToProps(this, {
            closeCart,
        });
    }

    handleNextClick = () => {
        this.nextClick();
        this.closeCart();
    }

    render() {
        return (
            <Fragment>
                <div class="ActionContainer">
                    <div class="CartContainer">
                        <rentware-cart-expandable
                            cartView={ComponentView.Checkout}
                            checkoutNextClick={this.handleNextClick}
                        />
                    </div>

                    <div class="ButtonContainer">
                        <rentware-button
                            appearance={{ noShadow: true }}
                            buttonText={this.buttonNextStepText}
                            onClick={this.handleNextClick}
                            isWaiting={this.isWaiting}
                        />
                    </div>
                </div>

                <div class="Blurred" />
            </Fragment>
        )
    }
}
